/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Empty({
  children,
  viewPath = "/DesignSystem/LoadingBar/Empty",
  height,
  width
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--h-1-4PwO0': typeof height === 'number' ? `${height}px` : height,'--w-2-4PwO0': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}